// Module
var code = "<template> <require from=\"app/core/pages/admin/member/member-contacts\"></require> <member-contacts member-id.bind=\"memberId\"></member-contacts> </template> ";
// Exports
module.exports = code;